export default __webpack_public_path__ + "img/twitter_icon.e2965285.svg";